<template>
    <div>
        <div class="text-right pb-3" v-if="allowMarking">
            <button type="button" :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" @click="allToDelivered">
                Доставлено
            </button>
            <button type="button" :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" @click="allToPaid">Оплачено</button>
            <button type="button" :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" class="btn ml-2" @click="allToPassed">Сдано</button>
        </div>
        <div class="text-right">
            <button @click.prevent="print" class="btn btn-warning ml-2" v-if="allowPrinting">Печать</button>
            <button type="button" class="btn btn-secondary ml-2" @click="$router.go(-1)">Назад</button>
        </div>
        <div class="mt-3" id="printMe">
            <table class="table table-sm table-borderless">
                <tbody>
                <tr>
                    <td>
                        Доставка: {{$route.query.time}}
                    </td>
                    <td>
                        <vue-barcode :value="courierBarCode" :width="2" height="20" :margin="0" display-value="false">
                            Ошибка штрихкода
                        </vue-barcode>
                    </td>
                    <td>
                        Курьер: {{courier.Mname}} {{courier.Lname}} {{courier.Fname}} ({{courier.Login}})
                    </td>
                    <td>
                        {{currentDate}}
                    </td>
                </tr>
                </tbody>
            </table>

            <div v-for="orders in customerOrders" class="small">
                <partner-delivery
                        @delivery-checkboxes-changed="checkBoxChanged"
                        :orders="orders"
                        :allow-deleting="false"
                        :allow-marking="allowMarking"
                        @part-amount-commit="commitPartAmount"
                ></partner-delivery>
            </div>
            <div class="font-weight-bold text-right">
                Итого доставка:<span v-for="paymentTypeSummary in summaries" class="ml-2">{{paymentTypeSummary.Name}}: {{paymentTypeSummary.Summary || 0}}</span>
            </div>
        </div>
        <form method="post" @submit.prevent="addOrder">
            <legend>Добавить заказ</legend>
            <div class="form-group">
                <div class="input-group">
                    <input type="number" class="form-control" placeholder="Номер сферы" v-model="sferaNumber" required ref="inputSferaNumber">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">Проверить и добавить</button>
                    </div>
                </div>
            </div>
        </form>
        <v-dialog/>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery.vue';
import { get, post, put } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
const type = 'partner';

export default {
  components: {
    PartnerDelivery,
    VueBarcode,
  },
  props: {
    time: String,
    panelUserId: [String, Number],
    allowPrinting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      orders: [],
      sferaNumber: '',
      courier: {},
      summaries: [],
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
    };
  },
  async created() {
    await this.fetchDebtByTourId();
    this.fetchCourier();
    this.calcAll();
  },
  watch: {
    orders() {
      this.calcAll();
    },
  },
  computed: {
    customerOrders() {
      return _.groupBy(this.orders, order => order.order.CustomerId);
    },
    courierBarCode() {
      return `cd_${this.$route.query.panelUserId}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    currentDate() {
      return moment()
        .format('DD-MM-YYYY, h:mm:ss');
    },
  },
  methods: {
    calcAll() {
      this.allIsDelivered = _.every(this.orders, item => item.delivery.IsDelivered);
      this.allIsPaid = _.every(this.orders, item => item.delivery.IsPaid);
      this.allIsPassed = _.every(this.orders, item => item.delivery.IsPassed);

      console.log('this.orders', this.orders);
      this.summaryCreated();
    },
    checkBoxChanged(data) {
      console.log('checkBoxChanged', data);
      this.markDeliveries(data.PropName, data.DeliveryIDs, data.value);
    },
    summaryCreated() {
      this.summaries = [];
      if (!this.orders) return;
      console.log('this.orders', this.orders);
      console.log('this.$root.paymentTypes', Object.assign({}, this.$root.paymentTypes));
      let tourSummary = _.cloneDeep(this.$root.paymentTypes);
      tourSummary = _.mapKeys(tourSummary, item => item.Id);
      console.log('tourSummary', tourSummary);
      _.forEach(this.orders, (order) => {
        tourSummary[order.order.PaymentTypeId].Summary = tourSummary[order.order.PaymentTypeId].Summary || 0;
        tourSummary[order.order.PaymentTypeId].Summary += order.order.Summary;
        console.log('tourSummary', tourSummary[order.order.PaymentTypeId].Summary);
      });
      // this.$nextTick(() => {
      //   this.$emit('summary-created', Object.assign({}, tourSummary));
      // });
      this.summaries = tourSummary;

      // console.log('this.orders', this.orders)
      // console.log('summaryCreated', Object.assign({}, data))
      // _.each(data, (v) => {
      //   const sumKey = _.findKey(this.summaries, { Id: v.Id });
      //   if (sumKey) {
      //     this.summaries[sumKey].Summary += Number(v.Summary);
      //   } else {
      //     this.summaries.push(v);
      //   }
      // });
    },
    async fetchDebtByTourId() {
      const { data } = await get(`${url}/by-time-and-panel-user/${type}`, this.$props);
      this.orders = data;
      console.log('fetchDelivery', this.orders);
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    async fetchCourier() {
      const { data } = await get(`${url}/couriers/${this.$route.query.panelUserId}`);
      this.courier = data;
    },
    async addOrder() {
      try {
        const { data } = await get(`${url}/is-in-delivery/${this.sferaNumber}`);
        const appendOrder = async () => {
          await post(`${url}/append-order-to-delivery/${this.sferaNumber}`, {
            DeliveryDate: this.$route.query.time,
            PanelUserId: this.$route.query.panelUserId,
          });
          this.fetchDebtByTourId();
          this.$modal.hide('dialog');
        };
        if (data) {
          this.$modal.show('dialog', {
            title: 'Предупреждение',
            text: `Заказ ${this.sferaNumber} уже есть в доставке на ${moment(String(data.DeliveryDate))
              .format('DD-MM-YYYY hh:mm')}`,
            buttons: [
              {
                title: 'Переназначить текущему пользователю', // Button title
                default: true, // Will be triggered by default if 'Enter' pressed.
                handler: appendOrder, // Button click handler
              },
              {
                title: 'Закрыть',
              },
            ],
          });
        } else {
          appendOrder();
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toasted.show(error.response.data, { type: 'error' });
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    getDeliveryIDs() {
      return _.map(this.orders, item => item.delivery.Id);
    },
    allToDelivered() {
      this.markDeliveries('IsDelivered', this.getDeliveryIDs(), this.allIsDelivered);
    },
    allToPaid() {
      this.markDeliveries('IsPaid', this.getDeliveryIDs(), this.allIsPaid);
    },
    allToPassed() {
      this.markDeliveries('IsPassed', this.getDeliveryIDs(), this.allIsPassed);
    },
    markDeliveries(PropName, DeliveryIDs, value) {
      let titlePropName;
      switch (PropName) {
        case 'IsDelivered':
          titlePropName = 'Доставлены';
          break;
        case 'IsPaid':
          titlePropName = 'Оплачены';
          break;
        case 'IsPartPaid':
          titlePropName = 'Частично оплачены';
          break;
        case 'IsPassed':
          titlePropName = 'Сданы';
          break;
        default:
          titlePropName = null;
      }
      const mark = async () => {
        console.log(!value);
        await post(`${url}/mark-deliveries`, {
          PropName,
          DeliveryIDs,
          value: !value,
        });
        this.fetchDebtByTourId();
        this.$modal.hide('dialog');
      };
      this.$modal.show('dialog', {
        title: 'Предупреждение',
        text: `Пометить доставки ${titlePropName ? `"${titlePropName}"` : ''}?`,
        buttons: [
          {
            title: 'Да', // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: mark,
          },
          {
            title: 'Отмена',
          },
        ],
      });
    },
    async commitPartAmount(data) {
      const { DeliveryId, PartAmount } = data;
      await put(url, { Id: DeliveryId, PartAmount });
      this.fetchDebtByTourId();
    },
  },
};
</script>
